import { DeliveryEntity } from "../../Objects/DeliveryEntity/DeliveryEntity"
import { DeliveryRouteOption } from "../../Objects/DeliveryEntity/DeliveryRouteOption"
import { EDeliveryStatusType } from "../../Enum/EDeliveryStatusType"

export const dedupeDeliveries = (list: DeliveryEntity[]) => {
  const byDeliveryId = new Map<number, DeliveryEntity>()

  list.forEach((item) => {
    const current = byDeliveryId.get(item.id)

    if (!current || item.updatedDatetime > current.updatedDatetime) {
      byDeliveryId.set(item.id, item)
    }
  })

  const byOrderId = new Map<number, DeliveryEntity>()

  Array.from(byDeliveryId.values()).forEach((item) => {
    const current = byOrderId.get(item.orderId)

    if (!current || item.updatedDatetime > current.updatedDatetime) {
      byOrderId.set(item.orderId, item)
    }
  })

  return Array.from(byOrderId.values()).sort((a, b) => b.updatedDatetime.getTime() - a.updatedDatetime.getTime())
}

export const filterActiveCourierDeliveries = (item: DeliveryEntity, now: Date) => {
  if (
    [
      EDeliveryStatusType.Pending,
      EDeliveryStatusType.Rejected,
      EDeliveryStatusType.Expired,
      EDeliveryStatusType.Canceled,
      EDeliveryStatusType.Delivered,
    ].includes(item.status)
  ) {
    return false
  }

  if (
    item.status === EDeliveryStatusType.Offered &&
    item.offerExpiresDateTime &&
    item.offerExpiresDateTime.getTime() <= now.getTime()
  ) {
    return false
  }

  return true
}

const ROUTE_RELEVANT_STATUSES = [EDeliveryStatusType.Accepted, EDeliveryStatusType.PickedUp, EDeliveryStatusType.OnRoute]

export const isRouteRelevantDelivery = (item: DeliveryEntity) => ROUTE_RELEVANT_STATUSES.includes(item.status)

export const countRouteRelevantDeliveries = (list: DeliveryEntity[]) => list.filter(isRouteRelevantDelivery).length

export function openMultiStopGoogleMaps(option: DeliveryRouteOption) {
  if (option.stops.length === 0) {
    return
  }

  const lastStop = option.stops[option.stops.length - 1]

  const waypoints = option.stops
    .slice(0, -1)
    .map((stop) => `${stop.latitude},${stop.longitude}`)
    .join("|")

  const url = new URL("https://www.google.com/maps/dir/")
  url.searchParams.set("api", "1")
  url.searchParams.set("destination", `${lastStop.latitude},${lastStop.longitude}`)

  if (waypoints) {
    url.searchParams.set("waypoints", waypoints)
  }

  window.open(url.toString(), "_blank")
}
